export const normalizePaymentItems = (paymentItems) => {
    if (!paymentItems) return [];
    return Array.isArray(paymentItems) ? paymentItems : Object.values(paymentItems);
};

export const isMedicinePaymentItem = (paymentItem) =>
    paymentItem?.invoiceType === 'MEDICINE';

export const getMedicineInvoicePrintUrl = (paymentItem) =>
    paymentItem?.additionalDetails?.printUrl;

/** Evital / inventory medicine invoice when there are no MEDICINE payment items */
export const getOrderMedicinePrintUrl = (sourceData) =>
    sourceData?.inventoryData?.print_url ||
    sourceData?.inventoryData?.printUrl ||
    null;

/** Medicine invoice URLs in print order: inventory/Evital bill first, then MEDICINE payment items. */
export const getMedicinePrintUrlsForOrder = (paymentItems, sourceData) => {
    const orderUrl = getOrderMedicinePrintUrl(sourceData);
    const fromPaymentItems = normalizePaymentItems(paymentItems)
        .filter(isMedicinePaymentItem)
        .map(getMedicineInvoicePrintUrl)
        .filter(Boolean);

    const urls = [];
    if (orderUrl) {
        urls.push(orderUrl);
    }
    fromPaymentItems.forEach((url) => {
        if (!urls.includes(url)) {
            urls.push(url);
        }
    });
    return urls;
};

export const getServicePaymentItems = (paymentItems) =>
    normalizePaymentItems(paymentItems).filter((item) => !isMedicinePaymentItem(item));

export const partitionPaymentItemsForPrint = (paymentItems) => {
    const items = normalizePaymentItems(paymentItems);
    return {
        medicineItems: items.filter(isMedicinePaymentItem),
        serviceItems: items.filter((item) => !isMedicinePaymentItem(item)),
    };
};
